<section class="trayectoria-section" id="trayectoria">
  <div class="container">
    <!-- Header -->
    <div class="trayectoria-header">
      <div class="title-wrapper">
        <p class="subtitle">Proyectos más importantes</p>
        <h2 class="title">Conoce Nuestra Trayectoria</h2>
      </div>
      <button class="btn-discover"
        routerLink="/proyectos"
      >
        Descubre más proyectos...
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>

    <!-- Category Filters -->
    <div class="category-filters">
      <button 
        *ngFor="let category of categories" 
        class="category-btn"
        [class.active]="selectedCategory === category"
        (click)="selectCategory(category)">
        {{ category }}
      </button>
    </div>

    <!-- Projects Grid -->
    <div class="projects-grid">
      <div class="project-card" *ngFor="let project of filteredProjects"
        routerLink="/proyectos/{{ project.title }}/{{ project.id }}"
      >
        <div class="project-image">
          <img [src]="project.imageUrl" [alt]="project.title" loading="lazy" />
        </div>
        <div class="project-info">
          <h3 class="project-title">{{ project.title }}</h3>
          <p class="project-location">{{ project.location }}</p>
        </div>
      </div>
    </div>
  </div>
</section>
